import {
  Button,
  Grid,
  MenuItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { createStakeholderApi } from "../../../components/api/StakeholderApiService";
import { recordStatus } from "../../../utils/menu-items";

const AddCustomer = (props) => {
  const navigate = useNavigate();
  const { setAddViewStates, addViewStates, rows, setRows, setAddView } = props;

  useEffect(() => {
    setAddViewStates((prev) => ({
      id: null,
      code: '',
      name: '',
      status: 'ACTIVE',
      type: "CUSTOMER",
      contactPersons: [],
      ...prev, 
    }));
  }, []);

  return (
    <>
      <Stack direcion="column">
        <Typography variant="body1" mb={2}>
          Create New Customer
        </Typography>
        <Grid container xs={12} spacing="8px">
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Customer Code</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              onChange={(e) =>
                setAddViewStates({
                  ...addViewStates,
                  code: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Customer Name</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              onChange={(e) =>
                setAddViewStates({
                  ...addViewStates,
                  name: e.target.value,
                })
              }
            />
          </Grid>
<Grid item xs={12}>
  <Typography variant="body2" sx={{ mb: 1 }}>
    Contact Persons
  </Typography>
  {addViewStates?.contactPersons && (
  <Table size="small" sx={{ border: "1px solid #ccc" }}>
    <TableHead>
      <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
        <TableCell>Default</TableCell>
        <TableCell>Name</TableCell>
        <TableCell>Email</TableCell>
        <TableCell>Phone 1</TableCell>
        <TableCell>Phone 2</TableCell>
        <TableCell>Position</TableCell>
        <TableCell align="center">Actions</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {(addViewStates.contactPersons || []).map((contact, idx) => (
        <TableRow key={idx}>
          <TableCell align="center">
            <Tooltip title={contact.isDefault ? "Default contact" : "Set as default"}>
              <span>
                <Button
                  size="small"
                  onClick={() => {
                    const updated = addViewStates.contactPersons.map((c, i) => ({ ...c, isDefault: i === idx }));
                    setAddViewStates({ ...addViewStates, contactPersons: updated });
                  }}
                  sx={{ minWidth: 0, p: 0.5, color: contact.isDefault ? "warning.main" : "action.disabled" }}
                >
                  {contact.isDefault ? <StarIcon fontSize="small" /> : <StarBorderIcon fontSize="small" />}
                </Button>
              </span>
            </Tooltip>
          </TableCell>
          <TableCell>
            <TextField
              variant="standard"
              value={contact.name}
              onChange={(e) => {
                const updated = [...addViewStates.contactPersons];
                updated[idx].name = e.target.value;
                setAddViewStates({ ...addViewStates, contactPersons: updated });
              }}
              fullWidth
            />
          </TableCell>
          <TableCell>
            <TextField
              variant="standard"
              value={contact.email}
              onChange={(e) => {
                const updated = [...addViewStates.contactPersons];
                updated[idx].email = e.target.value;
                setAddViewStates({ ...addViewStates, contactPersons: updated });
              }}
              fullWidth
            />
          </TableCell>
          <TableCell>
            <TextField
              variant="standard"
              value={contact.phoneNumberOne}
              onChange={(e) => {
                const updated = [...addViewStates.contactPersons];
                updated[idx].phoneNumberOne = e.target.value;
                setAddViewStates({ ...addViewStates, contactPersons: updated });
              }}
              fullWidth
            />
          </TableCell>
          <TableCell>
            <TextField
              variant="standard"
              value={contact.phoneNumberTwo}
              onChange={(e) => {
                const updated = [...addViewStates.contactPersons];
                updated[idx].phoneNumberTwo = e.target.value;
                setAddViewStates({ ...addViewStates, contactPersons: updated });
              }}
              fullWidth
            />
          </TableCell>
          <TableCell>
            <TextField
              variant="standard"
              value={contact.position}
              onChange={(e) => {
                const updated = [...addViewStates.contactPersons];
                updated[idx].position = e.target.value;
                setAddViewStates({ ...addViewStates, contactPersons: updated });
              }}
              fullWidth
            />
          </TableCell>
          <TableCell align="center">
            <Button
              color="error"
              size="small"
              onClick={() => {
                const updated = [...addViewStates.contactPersons];
                updated.splice(idx, 1);
                setAddViewStates({ ...addViewStates, contactPersons: updated });
              }}
            >
              Delete
            </Button>
          </TableCell>
        </TableRow>
      ))}
      <TableRow>
        <TableCell colSpan={7} align="center">
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              const updated = [...(addViewStates.contactPersons || [])];
              updated.push({
                name: "",
                email: "",
                phoneNumberOne: "",
                phoneNumberTwo: "",
                position: "",
                isDefault: updated.length === 0,
              });
              setAddViewStates({ ...addViewStates, contactPersons: updated });
            }}
          >
            + Add Contact Person
          </Button>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
  )}
</Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Status</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              label={"ACTIVE"}
              id="outlined-select-status"
              select
              onChange={(e) =>
                setAddViewStates({
                  ...addViewStates,
                  status: e.target.value,
                })
              }
            >
              {recordStatus.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
        <Stack direction="row" spacing={1} mt={1}>
          <Button variant="outlined" onClick={() => setAddView(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              const newId = Math.floor(Math.random() * 100000);
              setAddViewStates({ ...addViewStates, id: newId });
              setRows([addViewStates, ...rows]);
              setAddView(false);

              createStakeholderApi(addViewStates)
                .then((response) => {
                  toast.success("Customer added successfully.");
                  window.location.reload();
                  navigate("/customer-view");
                })
                .catch((error) => {
                  toast.error("Something went wrong.");
                  console.log(error.response.data);
                });
            }}
          >
            Add
          </Button>
        </Stack>
      </Stack>
    </>
  );
};

export default AddCustomer;
